<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- 查询条件 -->
			<div class="base_inquire">
				<div class="b_item">
					<span class="b_label">开始时间：</span>
					<el-date-picker
						v-model="search_startTime"
						:editable="false"
						placeholder="开始时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchStartTimeClick"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">结束时间：</span>
					<el-date-picker
						v-model="search_endTime"
						:editable="false"
						placeholder="结束时间"
						type="datetime"
						value-format="yyyy-MM-dd HH:mm:ss"
						@change="handleSearchEndTimeClick"
					>
					</el-date-picker>
				</div>
				
				<div class="b_item">
					<span class="b_label">产品类型：</span>
					<el-select v-model="search_product" class="b_inp" placeholder="请选择" :clearable="true">
						<el-option :value="-1" label="全部"></el-option>
						<el-option v-for="v in authProduct" :key="v.id" :value="v.id" :label="v.name"></el-option>
					</el-select>
				</div>
				
				<div class="b_item">
					<span class="b_label">区域：</span>
					<VDistpicker @province="handleSearchProvinceSelect" @city="handleSearchCitySelect" @area="handleSearchAreaSelect"></VDistpicker>
				</div>
				
				<div class="b_item">
					<span class="b_label">所属机构：</span>
					<el-input v-model="search_firm" class="b_inp" placeholder="所属机构"></el-input>
				</div>
				
				<div class="b_item">
					<span class="b_label">剩余次数：</span>
					<el-input v-model="search_num" class="b_inp" placeholder="剩余次数"></el-input>
				</div>

				<el-button type="primary" @click="handleSearchClick">查询</el-button>
			</div>
			<!-- 查询条件 end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="account"
						label="账号"
					>
					</el-table-column>
					<el-table-column
						prop="name"
						label="姓名"
					>
					</el-table-column>
					<el-table-column
						prop="firm"
						label="所属机构"
					>
					</el-table-column>
					<el-table-column
						prop="product"
						label="产品"
					>
					</el-table-column>
					<el-table-column
						prop="buyTimes"
						label="总购买次数"
					>
					</el-table-column>
					<el-table-column
						prop="costTimes"
						label="总消费次数"
					>
					</el-table-column>
					<el-table-column
						prop="remainTimes"
						label="剩余次数"
					>
					</el-table-column>
					<el-table-column
						prop="costTime"
						label="最后一次消费时间"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="300"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleRechargeRecordClick(scope.row)"
							>充值记录</el-button>
							<el-button
								@click="handleConsumeRecordClick(scope.row)"
							>消费记录</el-button>
							<el-button
								@click="handlePrescriptionClick(scope.row)"
							>处方</el-button>
							<el-button
								@click="handleTrainRecordClick(scope.row)"
							>训练记录</el-button>
							<el-button
								@click="handleHealthDocClick(scope.row)"
							>健康档案</el-button>
							<el-button
								@click="handleMedicalClick(scope.row)"
							>病历信息</el-button>
							<el-button
								@click="handleRevisitClick(scope.row)"
							>回访信息</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 充值记录弹出框 -->
		<RechargeRecord
			v-model="rechargeRecord_popup_display"
			:id="rechargeRecord_id"
			:code="rechargeRecord_code"
			type="0"
		></RechargeRecord>
		<!-- 充值记录弹出框 end -->
		
		<!-- 消费记录弹出框 -->
		<ConsumeRecord
			v-model="consumeRecord_popup_display"
			:id="consumeRecord_id"
			:code="consumeRecord_code"
			type="0"
		></ConsumeRecord>
		<!-- 消费记录弹出框 end -->
		
		<!-- 处方弹出框 -->
		<Prescription
			v-model="prescription_popup_display"
			:uid="prescription_uid"
			:fid="prescription_fid"
			:code="prescription_code"
			@updatePrescription="handleUpdatePrescription"
		></Prescription>
		<!-- 处方弹出框 end -->
		
		<!-- 训练记录弹出框 -->
		<TrainingRecord
			v-model="trainRecord_popup_display"
			:uid="trainRecord_uid"
			:fid="trainRecord_fid"
			:code="trainRecord_code"
		></TrainingRecord>
		<!-- 训练记录弹出框 end -->
		
		<!-- 健康档案弹出框 -->
		<HealthDoc
			:uid="healthDoc_uid"
			v-model="healthDoc_popup_display"
		></HealthDoc>
		<!-- 健康档案弹出框 end -->
		
		<!-- 病历弹出框 -->
		<Medical
			v-model="medical_popup_display"
			:code="medical_code"
			:formId="medical_firmId"
		></Medical>
		<!-- 病历弹出框 end -->
		
		<!-- 回访弹出框 -->
		<ReVisit
			v-model="revisit_popup_display"
			:uid="revisit_uid"
			@addRevisit="addRevisit"
			@deleteRevisit="deleteRevisit"
		></ReVisit>
		<!-- 回访弹出框 end -->
	</div>	
</template>

<script>
	import Api from '../../../../api/index.js';
	import { mapState } from 'vuex';
	import RechargeRecord from "./components/recharge_record.vue";
	import ConsumeRecord from "./components/consume_record.vue";
	import Prescription from "./components/prescription.vue";
	import TrainingRecord from "./components/training_record.vue";
	import HealthDoc from "./components/health_doc.vue";
	import Medical from "./components/medical.vue";
	import ReVisit from "./components/revisit.vue";
	
	export default {
		mounted() {
			this.getList();
		},
		data () {
			return {
				loading: false,
				
				tableData: [],
				total: 0,
				currentPage: 1,
				
				search_startTime: '',
				search_endTime: '',
				search_product: -1,
				search_addr: {
					provinceCode: '',
					provinceName: '',
					cityCode: '',
					cityName: '',
					areaCode: '',
					areaName: ''
				},
				search_firm: '',
				search_num: '',
				
				rechargeRecord_popup_display: false,
				rechargeRecord_id: '',
				rechargeRecord_code: '',
				
				consumeRecord_popup_display: false,
				consumeRecord_id: '',
				consumeRecord_code: '',
				
				prescription_popup_display: false,
				prescription_uid: '',
				prescription_fid: '',
				prescription_code: '',
				
				trainRecord_popup_display: false,
				trainRecord_uid: '',
				trainRecord_fid: '',
				trainRecord_code: '',
				
				healthDoc_popup_display: false,
				healthDoc_uid: '',
				
				medical_popup_display: false,
				medical_code: '',
				medical_firmId: '',
				
				revisit_popup_display: false,
				revisit_uid: ''
			}
		},
		computed: {
			...mapState(['authProduct'])
		},
		methods: {
			/************************ @Events *******************************/
			// 切换查询时间
			handleSearchStartTimeClick () {
				this.compareSearchTime();
			},
			// 切换查询时间
			handleSearchEndTimeClick () {
				this.compareSearchTime();
			},
			// 切换查询区域省份
			handleSearchProvinceSelect (data) {
				this.search_addr.provinceName = data.code ? data.value : '';
				this.search_addr.provinceCode = data.code ? data.code.slice(0, 3) : '';
			},
			// 切换查询区域城市
			handleSearchCitySelect (data) {
				this.search_addr.cityName = data.code ? data.value : '';
				this.search_addr.cityCode = data.code ? `${ data.code }000000` : '';
			},
			// 切换查询区域区域
			handleSearchAreaSelect (data) {
				this.search_addr.areaName = data.code ? data.value : '';
				this.search_addr.areaCode = data.code ? `${ data.code }000000` : '';
			},
			// 点击查询
			handleSearchClick () {
				this.currentPage = 1;
				this.getList();
			},
			// 切换页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			// 点击充值记录
			handleRechargeRecordClick (data) {
				if (!data.firmId) {
					this.$message.warning('该用户不属于任何机构，暂时无法查看充值记录！！！');
					return false;
				}
				this.rechargeRecord_id = data.firmId;
				this.rechargeRecord_code = data.account;
				this.rechargeRecord_popup_display = true;
			},
			// 点击消费记录
			handleConsumeRecordClick (data) {
				if (!data.firmId) {
					this.$message.warning('该用户不属于任何机构，暂时无法查看消费记录！！！');
					return false;
				}
				this.consumeRecord_id = data.firmId;
				this.consumeRecord_code = data.account;
				this.consumeRecord_popup_display = true;
			},
			// 点击处方
			handlePrescriptionClick (data) {
				if (!data.firmId) {
					this.$message.warning('该用户不属于任何机构，暂时无法查看处方！！！');
					return false;
				}
				this.prescription_uid = data.uid;
				this.prescription_fid = data.firmId;
				this.prescription_code = data.account;
				this.prescription_popup_display = true;
			},
			// 修改处方
			handleUpdatePrescription (msg) {
				this.$message({
					message: msg,
					type: 'success'
				});
			},
			// 点击训练记录
			handleTrainRecordClick (data) {
				if (!data.firmId) {
					this.$message.warning('该用户不属于任何机构，暂时无法查看训练记录！！！');
					return false;
				}
				this.trainRecord_uid = data.uid;
				this.trainRecord_fid = data.firmId;
				this.trainRecord_code = data.account;
				this.trainRecord_popup_display = true;
			},
			// 点击健康档案
			handleHealthDocClick (data) {
				this.healthDoc_uid = data.uid;
				this.healthDoc_popup_display = true;
			},
			// 点击病历
			handleMedicalClick (data) {
				this.medical_code = data.account;
				this.medical_firmId = data.firmId;
				this.medical_popup_display = true;
			},
			// 点击回访
			handleRevisitClick (data) {
				this.revisit_uid = data.uid;
				this.revisit_popup_display = true;
			},
			// 新增回访
			addRevisit (msg) {
				this.$message({
					message: msg,
					type: 'success'
				});
				this.revisit_popup_display = false;
			},
			// 删除回访
			deleteRevisit (msg) {
				this.$message({
					message: msg,
					type: 'success'
				});
				this.revisit_popup_display = false;
			},
			
			/************************ @Function *******************************/
			// 获取表格数据
			getList() {
				const that = this;
				that.loading = true;
				var requestData = {
					endTime: that.search_endTime,
					limit: 10,
					pageNum: that.currentPage,
					productType: that.search_product == -1 ? null : that.search_product,
					startTime: that.search_startTime,
					uareaCode: that.search_addr.areaCode,
					ucityCode: that.search_addr.cityCode,
					uenterpriseName: that.search_firm,
					uprovinceCode: that.search_addr.provinceCode,
					warning: that.search_num
				};
				Api.findAccountRenewal(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							var _o = res.data.data.data[i];
							that.tableData.push({
								uid: _o.userId,
								account: _o.ucode || '',
								name: _o.name || '',
								firmId: _o.enterpriseId || '',
								firm: _o.enterpriseName || '',
								product: that.mapProductTypeToName(_o.productType),
								buyTimes: _o.totalBuyTime || 0,
								costTimes: _o.totalConsTime || 0,
								remainTimes: _o.totalSurplusTime || 0,
								costTime: _o.lastTime || ''
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 把产品类型转换成名称
			mapProductTypeToName(type) {
				var name = '';
				this.authProduct.forEach(v => {
					v.id == type && (name = v.name);
				});
				return name;
			},
			// 比较开始时间和结束时间
			compareSearchTime () {
				if (this.search_startTime && this.search_endTime) {
					var startTime = new Date(this.search_startTime).getTime(),
						endTime = new Date(this.search_endTime).getTime();
					if (endTime < startTime) {
						this.search_endTime = '';
						this.$message({
							message: '结束时间不能小于开始时间',
							type: 'warning'
						});
					}
				}
			}
		},
		watch: {
			search_num(newVal) {
				!this.positiveReg.test(newVal) && (this.search_num = this.search_num.slice(0, this.search_num.length - 1));
			}
		},
		components: {
			RechargeRecord,
			ConsumeRecord,
			Prescription,
			TrainingRecord,
			HealthDoc,
			Medical,
			ReVisit
		}
	}
</script>

<style scoped>
</style>
